import ListingsList from "./ListingsList";
import SearchMap from "./SearchMap";

function Main() {
  return (
    <div className="app-annunci uk-position-relative">
      <div
        className="render-app-wrapper uk-child-width-1-2@m uk-grid-collapse swich-mobile-section"
        uk-grid=""
      >
        <div>
          <div className="search-map-wrap">
            <SearchMap />
          </div>
        </div>
        <div>
          <div className="listing-list-wrap">
            <ListingsList />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
